/* eslint-disable import/prefer-default-export */
export const MENU = Object.freeze({
  SOLUTIONS: 'SOLUTIONS',
  MORE_RESOURCES: 'MORE_RESOURCES'
});
